const transformHour = (hour: number, isDot?: boolean): string => {
    const hourNumb = hour > 12 ? hour - 12 : hour;
    const am = isDot ? 'a.m.' : 'am';
    const pm = isDot ? 'p.m.' : 'pm';
    const interval = hour < 12 || hour === 24 ? am : pm;
    return `${hourNumb} ${interval}`;
};

export default transformHour;
